/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { Image, Card, Avatar } from 'antd'
import Icon, {
  UserOutlined,
  RightOutlined,
  TagOutlined,
  EnvironmentOutlined,
  PhoneOutlined,
  GlobalOutlined,
  MobileOutlined,
} from '@ant-design/icons'
import intl from 'react-intl-universal'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper.min.css'
import 'swiper/components/pagination/pagination.min.css'
import 'swiper/components/navigation/navigation.min.css'
import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from 'swiper/core'
// import { timeFormat } from '../../utils'

import { Search, Dropdown } from 'antd-mobile'
import { GlobalOutline, MailFill, AppstoreOutline } from 'antd-mobile-icons'

import Nav from '../../component/nav/nav'
import Banner from '../../component/Banner/Banner'
import BreadCrumb from '../../component/BreadCrumb/BreadCrumb'
import Menus from '../../component/Menu/Menu'
import AdConsult from '../../component/AdConsult/AdConsult'
import Foot from '../../component/Foot/Foot'
import LeftTool from '../../component/LeftTool/LeftTool'
import PhoneChatList from '../../component/PhoneChatList/PhoneChatList'
import PopupSearch from '../../component/PopupSearch/PopupSearch'

import column from '../../api/column'
import merchantsInfo from '../../api/yellow'
import './components/yellwopagecss.css'

import ad1 from '../../assets/yellowpage/ad1.png'
import ad2 from '../../assets/yellowpage/ad2.png'
import ad3 from '../../assets/yellowpage/ad3.png'

import { ReactComponent as house } from '../../icons/menuicons/house.svg'
import { ReactComponent as car } from '../../icons/menuicons/car.svg'
import { ReactComponent as buessiness } from '../../icons/menuicons/buessiness.svg'
import { ReactComponent as medic } from '../../icons/menuicons/medic.svg'
import { ReactComponent as migrant } from '../../icons/menuicons/migrant.svg'
import { ReactComponent as Professional } from '../../icons/menuicons/Professional.svg'
import { ReactComponent as food } from '../../icons/menuicons/food.svg'
import { ReactComponent as home } from '../../icons/menuicons/home.svg'
import { ReactComponent as repair } from '../../icons/menuicons/repair.svg'

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay])

const { Meta } = Card

export default class YellowPages extends React.Component {
  constructor() {
    super()
    this.state = {
      breadArray: [
        {
          name: intl.get('KUNSHILANYISHOU'),
          path: '/main',
          navData: '1',
        },
        {
          name: intl.get('SHNGAJIA'),
          path: '/yellowpages',
          navData: '2',
        },
      ],
      menuArray: [],
      hotArray: [],
      normalData: [],
      normalShopData: [],
      iconsFilter: {
        38: (
          <Icon
            component={car}
            style={{ fontSize: '.25rem', color: '#3FD5D3' }}
            className="init-icons"
          />
        ),
        18: (
          <Icon
            component={house}
            style={{ fontSize: '.25rem', color: '#3FD5D3' }}
            className="init-icons"
          />
        ),
        17: (
          <Icon
            component={buessiness}
            style={{ fontSize: '.25rem', color: '#3FD5D3' }}
            className="init-icons"
          />
        ),
        16: (
          <Icon
            component={medic}
            style={{ fontSize: '.25rem', color: '#3FD5D3' }}
            className="init-icons"
          />
        ),
        15: (
          <Icon
            component={migrant}
            style={{ fontSize: '.25rem', color: '#3FD5D3' }}
            className="init-icons"
          />
        ),
        14: (
          <Icon
            component={Professional}
            style={{ fontSize: '.25rem', color: '#3FD5D3' }}
            className="init-icons"
          />
        ),
        13: (
          <Icon
            component={food}
            style={{ fontSize: '.25rem', color: '#3FD5D3' }}
            className="init-icons"
          />
        ),
        12: (
          <Icon
            component={home}
            style={{ fontSize: '.25rem', color: '#3FD5D3' }}
            className="init-icons"
          />
        ),
        11: (
          <Icon
            component={repair}
            style={{ fontSize: '.25rem', color: '#3FD5D3' }}
            className="init-icons"
          />
        ),
      },
      phoneNormalShopData: [],
      popvisible: false,
      navDataList: [],
      messageVisible: false,
      adList: [],
      adList2: [],
      adList3: [],

      secondCatetory: [],
      onSelectSecond: '',

      phoneAdTex: {
        11: intl.get('pingzhizhuanye'),
        12: intl.get('meihaojiaju'),
        13: intl.get('xiangshoushejian'),
        14: intl.get('duikourenchai'),
        15: intl.get('ziyuanfenfu'),
        16: intl.get('jiankangshenghuo'),
        17: intl.get('quanpinglei'),
        18: intl.get('youzhidichan'),
        38: intl.get('zhuanghuangmeirong'),
      },
    }
  }
  componentDidMount() {
    this.getMenuData()
    this.getHotData()
    this.getAds()
    this.getSecondCategory()
  }

  getAds = () => {
    merchantsInfo
      .advertisementList({})
      .then(res => res.json())
      .then(result => {
        if (result.ret === 200) {
          console.log('result.data', result.data)
          let apiData = result.data.filter(item => item.type === 7)
          let apiData_2 = result.data.filter(item => item.type === 8)
          let apiData_3 = result.data.filter(item => item.type === 12)

          console.log(
            'JSON.parse(apiData_2[0]?.path)',
            JSON.parse(apiData_2[0]?.path)
          )
          this.setState({
            adList: apiData[0]?.path
              ? JSON.parse(apiData[0]?.path)
              : [{ firstItemUrl: '', picPath: '' }],
            adList2: apiData_2[0]?.path
              ? JSON.parse(apiData_2[0]?.path)
              : [{ firstItemUrl: '', picPath: '' }],
            adList3: apiData_3[0]?.path
              ? JSON.parse(apiData_3[0]?.path)
              : [{ firstItemUrl: '', picPath: '' }],
          })
        }
      })
  }

  getMenuData = () => {
    const parms = {
      parentId: 2,
      language: sessionStorage['language'],
      stat: 1,
    }
    column
      .columnInfoWeb(parms)
      .then(res => res.json())
      .then(result => {
        if (result.ret === 200) {
          const temp = result.data.sort((it, it2) => {
            return it.id - it2.id
          })
          for (let i in temp) {
            temp[i].iconid = temp[i].id
            temp[i].title = temp[i].columnName
            temp[i].subTitle =
              temp[i].children.length > 1
                ? temp[i].children[temp[i].children.length - 1].columnName
                : ''
            temp[i].subTitle2 =
              temp[i].children.length > 2
                ? temp[i].children[temp[i].children.length - 2].columnName
                : ''
          }

          this.setState(
            {
              navDataList: result.data,
              menuArray: temp,
              normalData: result.data.map(item => {
                return {
                  id: item.id,
                  columnName: item.columnName,
                  children: [],
                }
              }),
            },
            () => {
              this.getNormalData()
            }
          )
        }
      })
  }

  getHotData = () => {
    const parms = {
      isHot: 1,
      stat: 1,
      language: sessionStorage['language'],
      pageSize: 20,
      pageNum: 1,
    }
    merchantsInfo
      .merchantsInfoListWeb(parms)
      .then(res => res.json())
      .then(result => {
        console.log('result3', result)
        if (result.ret === 200) {
          this.setState({
            hotArray: result.data.list,
          })
        }
      })
  }

  getNormalData = () => {
    const parms = {
      stat: 1,
      sort: 2,
      language: sessionStorage['language'],
      pageSize: 10000,
      pageNum: 1,
    }
    merchantsInfo
      .merchantsInfoListWeb(parms)
      .then(res => res.json())
      .then(result => {
        console.log('result4', result)
        if (result.ret === 200) {
          const arr = result.data.list
          let idArr = this.state.normalData
          for (let i in arr) {
            for (let j in idArr) {
              if (arr[i].firstCategory === idArr[j].id) {
                idArr[j].children.push(arr[i])
              }
            }
          }
          console.log('idArr', idArr)
          this.setState(
            {
              normalShopData: idArr,
              phoneNormalShopData: idArr,
            },
            () => {
              if (
                sessionStorage['MAINTYPE'] != undefined &&
                sessionStorage['MAINTYPE'] != null &&
                sessionStorage['MAINTYPE'] != 'undefined'
              ) {
                console.log('------------')
                sessionStorage['MAINTYPE'] = sessionStorage['MAINTYPE']
                this.handleClickSelect(sessionStorage['MAINTYPE'])
              } else {
                console.log('+++++++++++++')
                sessionStorage['MAINTYPE'] = ''
                this.handleClickSelect('')
              }
              // this.handleClickSelect(sessionStorage['MAINTYPE'])
            }
          )
        }
      })
  }

  filterIcon = id => {}

  handleFilter = () => {
    this.props.history.push('/yellowPageList')
  }

  getMenuId = (e, e2) => {
    console.log('eids', e, e2)
    sessionStorage['MAINTYPE'] = e
    sessionStorage['SECONDTYPE'] = e2
    this.props.history.push('/yellowPageList')
  }

  goToLIst = e => {
    sessionStorage['MAINTYPE'] = e.id ? e.id : ''
    sessionStorage['SECONDTYPE'] = ''
    this.props.history.push('/yellowPageList')
  }

  goToHot = () => {
    sessionStorage['ISHOT'] = 1
    this.props.history.push('/yellowPageList')
  }

  goToDetail = e => {
    console.log('e', e)
    sessionStorage['SHOPID'] = e
    let urlParms = JSON.stringify(e)
    this.props.history.push(`/yellowPagesDetail/${urlParms}`)
  }

  // 移动端============================================================================================================?===============================================================================================================================
  handleChangeNav = val => {
    console.log('val', val)
    sessionStorage['NAVITEM'] = val
    sessionStorage['MAINTYPE'] = ''
    sessionStorage['SECONDTYPE'] = ''
    sessionStorage['CITY'] = ''

    this.setState({})
    switch (Number(val)) {
      case 1:
        this.props.history.push('/main')
        break
      case 2:
        this.props.history.push('/yellowpages')
        break
      case 3:
        this.props.history.push('/bbspages')
        break
      case 4:
        this.props.history.push('/merchantsettled')
        break
      case 5:
        if (!JSON.parse(sessionStorage.getItem('USERDATA'))) {
          this.props.history.push('/login')
        } else {
          this.props.history.push('/myplace')
        }
        break
      default:
        break
    }
  }
  changeLanguage = val => {
    if (val === 'zh-CN') {
      sessionStorage['language'] = 1
      sessionStorage['languageTitle'] = '简体中文'
      sessionStorage['languageFilter'] = val
    } else if (val === 'en-US') {
      sessionStorage['language'] = 2
      sessionStorage['languageTitle'] = 'English'
      sessionStorage['languageFilter'] = val
    } else if (val === 'zh-CH') {
      sessionStorage['language'] = 3
      sessionStorage['languageTitle'] = '繁體中文'
      sessionStorage['languageFilter'] = val
    }
    window.location.reload()
  }

  handleClickSelect = e => {
    sessionStorage['MAINTYPE'] = e
    console.log('e', e)
    this.getSecondCategory()
    let filterData = []
    if (e !== '') {
      filterData = this.state.normalShopData.filter(item => {
        return item.id === Number(e)
      })
    } else {
      // 去掉热门推荐其他显示
      // filterData = this.state.normalShopData
    }
    this.setState({
      phoneNormalShopData: filterData,
    })
  }

  showChoice = () => {
    if (sessionStorage['MAINTYPE'] === '' || !sessionStorage['MAINTYPE']) {
      return (
        <>
          <div className="phone_bbs_gird_icons">
            <div
              className="phone_bbs_gird_icons_item"
              onClick={this.goToLIst.bind(this, { id: 11 })}
            >
              <div className="phone_bbs_gird_icons_item_icon">
                <div className="phone_shop_gird_icons_item_icon_item"></div>
              </div>
              <div className="phone_bbs_gird_icons_item_title">
                {intl.get('WEIXIUHZUANGHUANG')}
              </div>
            </div>

            <div
              className="phone_bbs_gird_icons_item"
              onClick={this.goToLIst.bind(this, { id: 12 })}
            >
              <div className="phone_bbs_gird_icons_item_icon">
                <div className="phone_shop_gird_icons_item_icon_item2"></div>
              </div>
              <div className="phone_bbs_gird_icons_item_title">
                {intl.get('JIAJUFUWU')}
              </div>
            </div>

            <div
              className="phone_bbs_gird_icons_item"
              onClick={this.goToLIst.bind(this, { id: 13 })}
            >
              <div className="phone_bbs_gird_icons_item_icon">
                <div className="phone_shop_gird_icons_item_icon_item3"></div>
              </div>
              <div className="phone_bbs_gird_icons_item_title">
                {intl.get('MEISHIYULE')}
              </div>
            </div>

            <div
              className="phone_bbs_gird_icons_item"
              onClick={this.goToLIst.bind(this, { id: 14 })}
            >
              <div className="phone_bbs_gird_icons_item_icon">
                <div className="phone_shop_gird_icons_item_icon_item4"></div>
              </div>
              <div className="phone_bbs_gird_icons_item_title">
                {intl.get('ZHUANGYERENSHI')}
              </div>
            </div>

            <div
              className="phone_bbs_gird_icons_item"
              onClick={this.goToLIst.bind(this, { id: 15 })}
            >
              <div className="phone_bbs_gird_icons_item_icon">
                <div className="phone_shop_gird_icons_item_icon_item5"></div>
              </div>
              <div className="phone_bbs_gird_icons_item_title">
                {intl.get('JIAOYUYIMINGJIUYE')}
              </div>
            </div>

            <div
              className="phone_bbs_gird_icons_item"
              onClick={this.goToLIst.bind(this, { id: 16 })}
            >
              <div className="phone_bbs_gird_icons_item_icon">
                <div className="phone_shop_gird_icons_item_icon_item6"></div>
              </div>
              <div className="phone_bbs_gird_icons_item_title">
                {intl.get('YILIAOBAOJIAN')}
              </div>
            </div>

            <div
              className="phone_bbs_gird_icons_item"
              onClick={this.goToLIst.bind(this, { id: 17 })}
            >
              <div className="phone_bbs_gird_icons_item_icon">
                <div className="phone_shop_gird_icons_item_icon_item7"></div>
              </div>
              <div className="phone_bbs_gird_icons_item_title">
                {intl.get('SHANGYEWUFU')}
              </div>
            </div>

            <div
              className="phone_bbs_gird_icons_item"
              onClick={this.goToLIst.bind(this, { id: 18 })}
            >
              <div className="phone_bbs_gird_icons_item_icon">
                <div className="phone_shop_gird_icons_item_icon_item8"></div>
              </div>
              <div className="phone_bbs_gird_icons_item_title">
                {intl.get('DICHANSHANGYETOUZI')}
              </div>
            </div>
          </div>

          <div className="phone_bbs_swipers">
            <Swiper spaceBetween={50} slidesPerView={1} autoplay>
              {this.state.adList.map((val, index) => {
                return (
                  <SwiperSlide key={index}>
                    <a href={val.firstItemUrl} target="_blank">
                      <div
                        style={{
                          height: '150px',
                          width: '100%',
                          background: '#fff',
                        }}
                      >
                        <div
                          style={{
                            width: '100%',
                            height: '100%',
                            background: `url(${val.picPath}) `,
                            backgroundSize: 'contain',
                            maxWidth: '100%',
                            maxHeight: '100%',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                          }}
                        ></div>
                      </div>
                    </a>
                  </SwiperSlide>
                )
              })}
            </Swiper>
          </div>
          <div className="phone_bbs_content">
            <div className="phone_bbs_content_title">
              <div className="phone_bbs_index_top_first_left_img"></div>
              {intl.get('REMENTUIJINA')}
            </div>
            <div className="phone_content_sort">
              <div className="phone_content_sort_item">
                {intl.get('ZUIXIN')}
              </div>
            </div>

            {this.state.hotArray.map(item => {
              return (
                <div
                  className="shop_content"
                  key={item.id}
                  onClick={this.goToDetail.bind(this, item.id)}
                >
                  <div className="shop_content_left">
                    {this.judgeIsTop(item.isTop)}

                    <Image
                      width={'8rem'}
                      height={'8rem'}
                      src={item.path ? item.path.split(',')[0] : ''}
                      fallback="data:image/png;base64,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"
                      preview={false}
                      style={{ borderRadius: '10px 10px 10px 10px' }}
                    />
                  </div>
                  <div className="shop_content_hot_right">
                    <div className="shop_content_right_title">
                      <span className="shop_content_right_title_name">
                        {item.merchantsName}
                      </span>{' '}
                    </div>
                    <div className="shop_content_right_item">
                      <TagOutlined style={{ color: '#42d8d9' }} />
                      <span className="shop_content_right_item_title">
                        {item.tags}
                      </span>
                    </div>

                    <div className="shop_content_right_item">
                      <EnvironmentOutlined style={{ color: '#42d8d9' }} />
                      <span className="shop_content_right_item_title">
                        {item.address}
                      </span>
                    </div>

                    <div className="shop_content_right_item">
                      <PhoneOutlined style={{ color: '#42d8d9' }} />
                      <span className="shop_content_right_item_title">
                        {item.phone}
                      </span>
                    </div>

                    <div className="shop_content_right_item">
                      <GlobalOutlined style={{ color: '#42d8d9' }} />
                      <span className="shop_content_right_item_title">
                        {item.webAddress}
                      </span>
                    </div>

                    <div className="shop_content_right_item">
                      <span className="shop_content_right_title_asked">
                        {intl.get('YIXIXUN')}{' '}
                      </span>
                      <span className="shop_content_right_item_title">
                        {item.clickNum}
                      </span>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </>
      )
    }
  }

  judgeIsTop = val => {
    if (val === 1) {
      return <div className="shop_content_left_top">{intl.get('ZHIDING')}</div>
    } else {
      return <div className="shop_content_left_top"></div>
    }
  }

  handleFocus = e => {
    this.setState({
      popvisible: true,
    })
    this.$phoneSearchEvent.searchFocus()
  }

  searchEvevnt = element => {
    this.$phoneSearchEvent = element
  }

  handleSetVisible = e => {
    this.setState({
      popvisible: false,
    })
  }

  handleGotoPerson = () => {
    if (!JSON.parse(sessionStorage.getItem('USERDATA'))) {
      this.props.history.push('/login')
    } else {
      this.props.history.push('/myplace')
    }
  }

  handleSeeMessage = () => {
    this.setState({
      messageVisible: true,
    })
  }

  getListClose = () => {
    this.setState({
      messageVisible: false,
    })
  }

  handleGotoConnectUS = () => {
    this.props.history.push('/connectus')
  }

  handleGotoMain = () => {
    this.props.history.push({ pathname: '/main' })
  }

  // 手机端黄页各个子分类

  getSecondCategory = async () => {
    let MAINTYPE = sessionStorage['MAINTYPE']

    let parentId =
      sessionStorage['MAINTYPE'] != undefined &&
      sessionStorage['MAINTYPE'] != null &&
      sessionStorage['MAINTYPE'] != 'undefined'
        ? sessionStorage['MAINTYPE']
        : 2

    console.log(parentId, 'parentId')
    const result = await column.columnInfoWeb({
      parentId: parentId,
      language: sessionStorage['language'],
      stat: 1,
    })
    let apiData = await result.json()
    console.log(apiData, 'apiData')

    this.setState({
      secondCatetory: apiData?.data
        .sort((item1, item2) => {
          return item1.id - item2.id
        })
        .map(item => {
          return {
            columnName: item.columnName,
            id: item.id,
          }
        }),
    })
  }

  yellowSecondCategory = () => {
    if (sessionStorage['MAINTYPE'] !== '' || sessionStorage['MAINTYPE']) {
      return (
        <>
          <div className="phone_bbs_second_category">
            {this.state.secondCatetory.map((item, index) => {
              return (
                <div
                  className={
                    this.state.onSelectSecond === item.id
                      ? 'phone_bbs_second_category_item_active'
                      : 'phone_bbs_second_category_item'
                  }
                  key={item.id}
                  onClick={this.handleSelectSecond.bind(this, item)}
                >
                  {item.columnName}
                </div>
              )
            })}
          </div>
        </>
      )
    }
  }

  handleSelectSecond = async item => {
    console.log('this.state', this.state.normalShopData)
    const apiData = await merchantsInfo.merchantsInfoListWeb({
      merchantsName: sessionStorage['SHOPSEARCHPARMS'],
      sort: sessionStorage['SORT'],
      language: sessionStorage['language'],
      firstCategory:
        sessionStorage['MAINTYPE'] !== undefined &&
        sessionStorage['MAINTYPE'] !== null
          ? sessionStorage['MAINTYPE']
          : 11,
      merchantsType: item.id,
      pageSize: 100,
      pageNum: 1,
    })
    const filterData = await apiData.json()
    let personList = [
      {
        columnName: item.columnName,
        children: filterData.data.list,
      },
    ]
    console.log('filterData', filterData)

    this.setState({
      phoneNormalShopData: personList,
      onSelectSecond: item.id,
    })
  }

  render() {
    document.title = 'EQLD昆士兰易搜黄页-昆士兰首家中英双语黄页'
    document
      .querySelector('meta[property="og:title"]')
      .setAttribute('content', 'EQLD昆士兰易搜黄页')
    document
      .querySelector('meta[property="og:description"]')
      .setAttribute(
        'content',
        '寻昆州本地服务，找各行业信赖商家，尽在易搜黄页！'
      )
    document
      .querySelector('meta[itemprop="description"]')
      .setAttribute(
        'content',
        '寻昆州本地服务，找各行业信赖商家，尽在易搜黄页！'
      )
    document
      .querySelector('meta[property="og:type"]')
      .setAttribute('content', 'website')
    document
      .querySelector('meta[property="og:image"]')
      .setAttribute(
        'content',
        'http://icon.mobanwang.com/UploadFiles_8971/200910/20091011134333685.png'
      )
    document
      .querySelector('meta[itemprop="image"]')
      .setAttribute(
        'content',
        'http://icon.mobanwang.com/UploadFiles_8971/200910/20091011134333685.png'
      )
    document
      .querySelector('meta[itemprop="name"]')
      .setAttribute('content', 'EQLD昆士兰易搜黄页')
    return (
      <>
        <div className="main_content">
          <Nav history={this.props.history} props={this.props} />
          <Banner
            type="1"
            history={this.props.history}
            setBannerSearch={this.handleFilter}
          />
          <BreadCrumb
            history={this.props.history}
            breadData={this.state.breadArray}
          />
          <div className="yellowpage_menu">
            <div className="yellowpage_menu_left">
              <Menus
                menuData={this.state.menuArray}
                history={this.props.history}
                setMenuId={this.getMenuId}
                menuType={1}
              />
            </div>
            <div className="yellowpage_menu_right">
              <div className="yellowpage_menu_right_top">
                <Swiper
                  spaceBetween={50}
                  slidesPerView={1}
                  loop={true}
                  autoplay={{
                    pauseOnMouseEnter: true,
                    disableOnInteraction: false,
                  }}
                >
                  {this.state.adList.map((val, index) => {
                    return (
                      <SwiperSlide key={index}>
                        <a href={val.firstItemUrl} target="_blank">
                          <Image
                            width="8.16rem"
                            height="3.4rem"
                            preview={false}
                            src={val.picPath}
                          />
                        </a>
                      </SwiperSlide>
                    )
                  })}
                </Swiper>
              </div>
              <div className="yellowpage_menu_right_bottom">
                <div className="yellowpage_menu_right_bottom_left">
                  <a href={this.state.adList2[0]?.firstItemUrl} target="_blank">
                    <Image
                      width="4.08rem"
                      height="1.82rem"
                      preview={false}
                      src={this.state.adList2[0]?.picPath}
                    />
                  </a>
                </div>
                <div className="yellowpage_menu_right_bottom_right">
                  <a href={this.state.adList2[0]?.firstItemUrl} target="_blank">
                    <Image
                      width="4.08rem"
                      height="1.82rem"
                      preview={false}
                      src={this.state.adList2[1]?.picPath}
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="yellowpage_content">
            {/* 热门推荐 */}
            <div className="hot_recommend">
              <div className="hot_recommend_title">
                <div className="hot_recommend_title_left">
                  <div className="hot_recommend_title_icon"></div>
                  <div className="hot_recommend_title_text">
                    {intl.get('REMENTUIJINA')}
                  </div>
                  <div className="hot_recommend_title_flag">
                    {intl.get('WOMENWEININTUJINA')}
                  </div>
                </div>
                <div
                  className="hot_recommend_title_right customer_hover"
                  onClick={this.goToHot.bind(this, {})}
                >
                  <div className="hot_recommend_title_right_text">
                    {intl.get('GENGDUOSHANGJAI')}
                  </div>
                  <div className="hot_recommend_title_right_icon"></div>
                </div>
              </div>

              <div className="hot_recommend_content">
                <Swiper
                  spaceBetween={200}
                  slidesPerView={4}
                  loop={true}
                  autoplay={{
                    pauseOnMouseEnter: true,
                    disableOnInteraction: false,
                  }}
                >
                  {this.state.hotArray.map((item, index) => {
                    return (
                      <SwiperSlide key={index}>
                        <div
                          className="hot_recommend_content_item"
                          onClick={this.goToDetail.bind(this, item.id)}
                        >
                          {item.isTop == 1 ? (
                            <div className="hot_recommend_content_top">
                              <div className="hot_recommend_content_top_icon"></div>
                              <div className="hot_recommend_content_top_text">
                                {intl.get('ZHIDING')}
                              </div>
                            </div>
                          ) : (
                            <div className="hot_recommend_content_top no_top"></div>
                          )}
                          {/* <div className="hot_recommend_content_top">
                            <div className="hot_recommend_content_top_icon"></div>
                            <div className="hot_recommend_content_top_text">
                              {intl.get('ZHIDING')}
                            </div>
                          </div> */}
                          <Card
                            hoverable
                            bordered={false}
                            style={{
                              width: '3rem',
                              filter:
                                'drop-shadow(0px 4px 16px rgba(0, 0, 0, 0.12))',
                              borderRadius: '10px',
                            }}
                            bodyStyle={{
                              background: '#18B2B0',
                              color: '#ffffff',
                              borderRadius: ' 0 0 10px 10px',
                              height: '0.87rem',
                            }}
                            cover={
                              <Image
                                width={'3rem'}
                                height={'2.8rem'}
                                src={item.path ? item.path.split(',')[0] : ''}
                                fallback="data:image/png;base64,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"
                                preview={false}
                                style={{ borderRadius: '10px 10px 0 0' }}
                              />
                            }
                          >
                            <Meta
                              title={item.merchantsName}
                              description={item.tags}
                              className="card_meta"
                            />
                          </Card>
                        </div>
                      </SwiperSlide>
                    )
                  })}
                </Swiper>
              </div>
            </div>

            {/* 各个分类 */}

            {
              // eslint-disable-next-line array-callback-return
              this.state.normalShopData.map((item, index) => {
                if (item.children.length !== 0) {
                  return (
                    <div className="normal_shop" key={index}>
                      <div className="normal_shop_title">
                        <div className="normal_shop_title_left">
                          <div className="normal_shop_title_icon">
                            {this.state.iconsFilter[item.id]}
                          </div>
                          <div className="normal_shop_title_text">
                            {item.columnName}
                          </div>
                          <div className="normal_shop_title_flag">
                            {/* {intl.get('WOMENWEININTUJINA')} */}
                          </div>
                        </div>
                        <div
                          className="normal_shop_title_right customer_hover"
                          onClick={this.goToLIst.bind(this, item)}
                        >
                          <div className="normal_shop_title_right_text">
                            {intl.get('GENGDUOSHANGJAI')}
                          </div>
                          <div className="normal_shop_title_right_icon"></div>
                        </div>
                      </div>

                      <div className="normal_shop_content">
                        <Swiper
                          spaceBetween={100}
                          slidesPerView={6}
                          loop={true}
                        >
                          {item.children.map((item2, index2) => {
                            return (
                              <SwiperSlide key={index2}>
                                <div
                                  className="normal_shop_content_item"
                                  onClick={this.goToDetail.bind(this, item2.id)}
                                >
                                  <Card
                                    hoverable
                                    bordered={false}
                                    style={{
                                      width: '2.08rem',
                                      filter:
                                        'drop-shadow(0px 4px 16px rgba(0, 0, 0, 0.12))',
                                      borderRadius: '10px',
                                    }}
                                    bodyStyle={{
                                      background: '#fff',
                                      color: '#ffffff',
                                      borderRadius: ' 0 0 10px 10px',
                                      height: '0.7rem',
                                      padding: '0.24rem',
                                    }}
                                    cover={
                                      <Image
                                        width={'2.08rem'}
                                        height={'2.1rem'}
                                        src={
                                          item2.path
                                            ? item2.path.split(',')[0]
                                            : ''
                                        }
                                        fallback="data:image/png;base64,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"
                                        preview={false}
                                        style={{
                                          borderRadius: '10px 10px 0 0',
                                        }}
                                      />
                                    }
                                  >
                                    <Meta
                                      title={item2.merchantsName}
                                      description={item2.tags}
                                      className="normal_card_meta"
                                    />
                                  </Card>
                                </div>
                              </SwiperSlide>
                            )
                          })}
                        </Swiper>
                      </div>
                    </div>
                  )
                }
              })
            }
          </div>
          <AdConsult industyData={this.state.menuArray} />
          <Foot history={this.props.history} />
          <LeftTool history={this.props.history} />
          <div className="right_ads">
            {this.state.adList3.map(item => {
              return (
                <a href={item.firstItemUrl} target="_blank" key={item.id}>
                  <Image
                    width="1.6rem"
                    height="2rem"
                    preview={false}
                    src={item.picPath}
                  />
                </a>
              )
            })}
          </div>
        </div>

        {/* 移动端==============================================================================================================================================================================================================================> */}

        <div className="phone_content bbs_phone_content">
          <div className="phone_bbs_index_top">
            <div className="phone_bbs_index_top_first">
              <div className="phone_bbs_index_top_first_left">
                <div className="phone_bbs_index_top_first_left_img"></div>
                <span className="phone_bbs_index_top_first_left_text">
                  {intl.get('YISOUSHUANGYE')}
                </span>
              </div>
              <div
                className="phone_bbs_index_top_first_right"
                onClick={this.handleGotoMain}
              ></div>
            </div>

            <div className="phone_bbs_index_search">
              <div className="phone_bbs_index_search_avatar">
                <Avatar
                  size={40}
                  icon={<UserOutlined />}
                  src={
                    sessionStorage.getItem('USERDATA')
                      ? JSON.parse(sessionStorage.getItem('USERDATA'))?.customer
                          ?.path
                      : ''
                  }
                  onClick={this.handleGotoPerson}
                />
              </div>
              <div className="phone_bbs_index_search_input">
                <Search
                  placeholder={intl.get('KUNSHILANYISHOU')}
                  className="phone_bbs_index_search_input_item"
                  onFocus={this.handleFocus}
                />
                <PopupSearch
                  visible={this.state.popvisible}
                  type="1"
                  history={this.props.history}
                  setVisible={this.handleSetVisible}
                  searchEvevnt={this.searchEvevnt}
                />
              </div>
              <div className="phone_bbs_index_search_icons">
                <div className="phone_bbs_index_search_icons_item">
                  <MailFill fontSize={20} onClick={this.handleSeeMessage} />
                  <PhoneChatList
                    messageVisible={this.state.messageVisible}
                    listClose={this.getListClose}
                  />
                </div>
                <div className="phone_bbs_index_search_icons_item">
                  <Dropdown>
                    <Dropdown.Item
                      key="sorter"
                      title={
                        <>
                          <GlobalOutline fontSize={20} />
                        </>
                      }
                    >
                      <div style={{ padding: 12 }}>
                        <div
                          className="sorter_item2"
                          onClick={this.changeLanguage.bind(this, 'zh-CN')}
                        >
                          {intl.get('JIANTIZHONGWEN')}
                          <RightOutlined />
                        </div>
                        <div
                          className="sorter_item2"
                          onClick={this.changeLanguage.bind(this, 'en-US')}
                        >
                          {intl.get('ENGLISH')}
                          <RightOutlined />
                        </div>
                        <div
                          className="sorter_item2"
                          onClick={this.changeLanguage.bind(this, 'zh-CH')}
                        >
                          {intl.get('FANTIZHONGWEN')}
                          <RightOutlined />
                        </div>
                      </div>
                    </Dropdown.Item>
                  </Dropdown>
                </div>
                <div className="phone_bbs_index_search_icons_item">
                  <Dropdown>
                    <Dropdown.Item
                      key="sorter"
                      title={
                        <>
                          <AppstoreOutline fontSize={20} />
                        </>
                      }
                    >
                      <div className="sorterList" style={{ padding: 12 }}>
                        <div
                          className="sorter_item"
                          onClick={this.handleChangeNav.bind(this, 1)}
                        >
                          {intl.get('SHOUYE')}
                        </div>
                        <div
                          className="sorter_item"
                          onClick={this.handleChangeNav.bind(this, 2)}
                        >
                          {intl.get('SHANGJIAHUANG')}
                        </div>
                        <div
                          className="sorter_item"
                          onClick={this.handleChangeNav.bind(this, 3)}
                        >
                          {intl.get('YISHOULUNT')}
                        </div>
                        <div
                          className="sorter_item"
                          onClick={this.handleChangeNav.bind(this, 4)}
                        >
                          {intl.get('SHANGJAIRUZHU')}
                        </div>
                        <div
                          className="sorter_item"
                          onClick={this.handleChangeNav.bind(this, 5)}
                        >
                          {intl.get('WODEYISOU')}
                        </div>
                      </div>
                    </Dropdown.Item>
                  </Dropdown>
                </div>
              </div>
            </div>
            <div className="phone_bbs_index_tabs">
              <div
                className="phone_bbs_index_tabs_item"
                onClick={this.handleClickSelect.bind(this, '')}
              >
                <div
                  className={
                    !sessionStorage['MAINTYPE']
                      ? 'phone_bbs_index_tabs_item_title_active'
                      : 'phone_bbs_index_tabs_item_title'
                  }
                >
                  {' '}
                  {intl.get('TUIJIANCAIFUWU')}
                </div>
                <div
                  className={
                    !sessionStorage['MAINTYPE']
                      ? 'phone_bbs_index_tabs_item_subtitle_active'
                      : 'phone_bbs_index_tabs_item_subtitle'
                  }
                >
                  {' '}
                  {intl.get('WEINITUIJIAN')}
                </div>
              </div>

              {this.state.navDataList.map(item => {
                return (
                  <div
                    className="phone_bbs_index_tabs_item"
                    key={item.id}
                    onClick={this.handleClickSelect.bind(this, item.id)}
                  >
                    <div
                      className={
                        Number(sessionStorage['MAINTYPE']) === item.id
                          ? 'phone_bbs_index_tabs_item_title_active'
                          : 'phone_bbs_index_tabs_item_title'
                      }
                    >
                      {item.columnName}
                    </div>
                    <div
                      className={
                        Number(sessionStorage['MAINTYPE']) === item.id
                          ? 'phone_bbs_index_tabs_item_subtitle_active'
                          : 'phone_bbs_index_tabs_item_subtitle'
                      }
                    >
                      {this.state.phoneAdTex[item.id]}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
          {this.showChoice()}

          {this.yellowSecondCategory()}

          {this.state.phoneNormalShopData.map((item, index) => {
            return (
              <div className="phone_yellow_content" key={index}>
                <div className="phone_bbs_content_title">
                  <div className="phone_bbs_index_top_first_left_img"></div>
                  {item.columnName}
                </div>
                <div className="phone_content_sort">
                  <div className="phone_content_sort_item">
                    {intl.get('ZUIXIN')}
                  </div>
                </div>

                {item.children.map(item2 => {
                  return (
                    <div
                      className="shop_content"
                      key={item2.id}
                      onClick={this.goToDetail.bind(this, item2.id)}
                    >
                      <div className="shop_content_left">
                        <Image
                          width={'8rem'}
                          height={'8rem'}
                          src={item2.path ? item2.path.split(',')[0] : ''}
                          fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
                          preview={false}
                          style={{ borderRadius: '10px 10px 10px 10px' }}
                        />
                      </div>
                      <div className="shop_content_right">
                        <div className="shop_content_right_title">
                          <span className="shop_content_right_title_name">
                            {item2.merchantsName}
                          </span>{' '}
                        </div>
                        <div className="shop_content_right_item">
                          <TagOutlined style={{ color: '#42d8d9' }} />
                          <span className="shop_content_right_item_title">
                            {item2.tags}
                          </span>
                        </div>

                        <div className="shop_content_right_item">
                          <GlobalOutlined style={{ color: '#42d8d9' }} />
                          <span className="shop_content_right_item_title">
                            {item2.webAddress}
                          </span>
                        </div>
                        <div className="shop_content_right_item">
                          <PhoneOutlined style={{ color: '#42d8d9' }} />
                          <span className="shop_content_right_item_title">
                            {item2.phone}
                          </span>
                        </div>

                        <div className="shop_content_right_item">
                          <EnvironmentOutlined style={{ color: '#42d8d9' }} />
                          <span className="shop_content_right_item_title">
                            {item2.address}
                          </span>
                        </div>

                        <div className="shop_content_right_item">
                          <span className="shop_content_right_title_asked">
                            {intl.get('YIXIXUN')}{' '}
                          </span>
                          <span className="shop_content_right_item_title">
                            {item2.clickNum}
                          </span>
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            )
          })}

          <div className="phone_post_bbs">
            <div
              className="phone_post_bbs_item"
              onClick={this.handleGotoConnectUS}
            >
              <div className="phone_post_bbs_item_icon">
                <MobileOutlined />
              </div>
              <div className="phone_post_bbs_item_title">
                {intl.get('LIANXIWOMEN')}
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}
